import { Icon } from '@chakra-ui/icons';
import React from 'react';
import { DefaultIconProps } from '../IconType';

export const ButtonVector1 = ({
  opacity = 0.2,
  // If this is not set to auto (instead of 100%) then safari will force the <svg> to take up 100% width while the <path>s are centered w/in that space. This was an issue on the signup and login forms
  width = `auto`,
  height = `100%`,
  boxSize,
  variant = `small`,
  ...props
}: DefaultIconProps & { variant?: 'small' | 'height' | 'xheight' }) => {
  let viewBox = ``;
  let paths = null;

  switch (variant) {
    case `xheight`:
      viewBox = `0 0 13 201`;
      paths = (
        <path
          d="M1.00798 3.4862e-10L1.00803 150.312C0.848026 164.132 3.01708 200 13 200"
          stroke="currentColor"
          strokeOpacity={opacity}
        />
      );
      break;
    case `height`:
      viewBox = `0 0 13 129`;
      paths = (
        <path
          d="M1.00798 3.4862e-10L1.00803 96.1998C0.848029 105.044 3.01708 128 13 128"
          stroke="currentColor"
          strokeOpacity={opacity}
        />
      );
      break;
    case `small`:
    default:
      viewBox = `0 0 91 80`;
      paths = (
        <path
          d="M1.00798 0.978027L1.00803 60.3514C0.84803 65.8101 3.01708 79.978 13 79.978"
          stroke="currentColor"
          strokeOpacity={opacity}
        />
      );
      break;
  }

  return (
    <Icon
      viewBox={viewBox}
      style={{
        ...(!boxSize && { width }),
        ...(!boxSize && { height }),
        fill: `none`,
      }}
      boxSize={boxSize}
      {...props}
    >
      {paths}
    </Icon>
  );
};

export default ButtonVector1;
